export default function () {
  this.$refs.importModule.showDialog = true
}